import {Home, Zap, Users, Circle, Settings, Search, MapPin} from 'react-feather'

import langConfig from "@configs/langConfig";
import {userRoleName} from "@hooks/useUserRole";

const {t} = langConfig

const adminNav = [
    {
        id: 'dashboard',
        title: t('Dashboard'),
        icon: <Home size={20}/>,
        navLink: '/dashboard'
    },
    {
        id: 'search',
        title: t('Search'),
        icon: <Search size={20}/>,
        navLink: '/search'
    },
    {
        id: 'users',
        title: t('Users'),
        icon: <Users size={20}/>,
        navLink: '/admin/users'
    },
    {
        id: 'phishing-feed',
        title: t('Phishing feed'),
        icon: <Zap size={20}/>,
        children: [
            {
                id: 'admin-phishing-feed',
                title: t('Admin'),
                icon: <Circle/>,
                navLink: '/admin/phishing-feed'
            },
            {
                id: 'user-phishing-feeds',
                title: t('User'),
                icon: <Circle/>,
                navLink: '/user/phishing-feeds'
            }
        ]
    },
    {
        id: 'settings',
        title: t('menu.Settings'),
        icon: <Settings/>,
        children: [
            {
                id: 'audiences',
                title: t('menu.Audiences'),
                icon: <Circle/>,
                navLink: '/admin/settings/audiences'
            },
            {
                id: 'industries',
                title: t('Industries'),
                icon: <Circle/>,
                navLink: '/admin/settings/industries'
            },
            {
                id: 'status-type',
                title: t('Status type'),
                icon: <Circle/>,
                navLink: '/admin/settings/status-type'
            },
            {
                id: 'organizations',
                title: t('Organizations'),
                icon: <Circle/>,
                navLink: '/admin/settings/organizations'
            },
            {
                id: 'threat-actors',
                title: t('Threat Actors'),
                icon: <Circle/>,
                navLink: '/admin/settings/threat-actors'
            },
            {
                id: 'tactics',
                title: t('Tactics'),
                icon: <Circle/>,
                navLink: '/admin/settings/tactics'
            },
            {
                id: 'channels',
                title: t('Channels'),
                icon: <Circle/>,
                navLink: '/admin/settings/channels'
            },
            {
                id: 'severities',
                title: t('Severities'),
                icon: <Circle/>,
                navLink: '/admin/settings/severities'
            },
            {
                id: 'apiKeys',
                title: t('Api keys'),
                icon: <Circle/>,
                navLink: '/admin/settings/api/keys'
            }
        ]
    }
]

const userNav = [
    {
        id: 'dashboard',
        title: t('Dashboard'),
        icon: <Home size={20}/>,
        navLink: '/dashboard'
    },
    {
        id: 'search',
        title: t('Search'),
        icon: <Search size={20}/>,
        navLink: '/search'
    },
    {
        id: 'phishing-feed',
        title: t('Phishing feed'),
        icon: <Zap size={20}/>,
        navLink: '/user/phishing-feeds'
    },
]

const userRol = _ => {
    return userRoleName()
}

const userList = userRol() === 'admin' ? adminNav : userNav

export default userList
